import { Form, Input } from "antd";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import styles from './_ComplianceFiltroForm.less';
import { SearchOutlined } from "@ant-design/icons";
import { complianceFiltroAplicar, complianceFiltroSelector } from "../../../store/complianceFiltro";
import { useSelector } from "react-redux";
import { acessoSelector } from "../../../store/acessos";
import ActionButton from "../../../components/action-button";
import { fetchEmpresas } from "../../../store/empresas";
import useLoading from "../../../hooks/useLoading";

export default function ComplianceFiltroForm() {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const loading = useLoading(fetchEmpresas.typePrefix);
  const filtro = useSelector(complianceFiltroSelector);
  const acesso = useSelector(acessoSelector);
  const acessoId = acesso?.id;

  useEffect(() => {
    if (!filtro.inicializado) {
      if (acessoId)
        dispatch(complianceFiltroAplicar({ search: '' }));
    }
  }, [])

  useEffect(() => {
    form.setFieldsValue(filtro);
  }, [filtro])

  const handleFinish = useCallback(values => {
    dispatch(complianceFiltroAplicar(values));
    dispatch(fetchEmpresas({ search: values.search, acessoId, modulo: 'compliance' }));
  }, [acessoId]);

  return (
    <Form form={form} noValidate initialValues={filtro} onFinish={handleFinish}>
      <div className={styles.ComplianceFiltroForm}>
        <div className={styles.search}>
          <Form.Item name="search" noStyle>
            <Input autoFocus/>
          </Form.Item>
        </div>
        <div>
          <ActionButton primary icon={<SearchOutlined/>} loading={loading} htmlType="submit">
            {t('Pesquisar')}
          </ActionButton>
        </div>
      </div>
    </Form>
  )
}
